/**
 * Asynchronously loads the component for AskMiaAutopilotPage
 */

import { lazyLoad } from 'utils/loadable';

export const AskMiaAutopilotPage = lazyLoad(
  () => import('./AskMiaAutopilotPage'),
  module => module.default,
);
